import { z } from 'zod';

export const FooterLinkSchema = z.object({
  name: z.string(),
  url: z.string(),
});
export const FooterConfigurationSchema = z.object({
  links: z.array(FooterLinkSchema),
});
